import React from 'react';
import styled from 'styled-components';

import { GENDERS } from '@front/common/src/constants/accounts';
import type { Salutation } from '@front/common/src/types/commons';
import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import Radio from '../radio/radio';
import Text from '../base-text/variants/text';
import BottomMessage from '../input/components/bottom-message';

export const GenderSelectorContainer = styled.div`
  margin-bottom: 15px;
  gap: ${toRem(20)};
`;

const RadioContainer = styled.div`
  display: flex;
  gap: ${toRem(20)};
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const t = translate('screens.signup.user');

type GenderSelectorProps = {
  value?: string;
  error?: string;
  onChange: (gender: Salutation) => void;
  className?: string;
};

const GenderSelector = React.forwardRef<HTMLInputElement, GenderSelectorProps>(
  ({ value: gender, onChange, error, className }, ref) => (
    <GenderSelectorContainer className={className}>
      <RadioContainer>
        {GENDERS.map(({ key, value }) => (
          <Label key={key}>
            <Radio
              checked={gender === value}
              id={`salutation-${value}`}
              name='salutation'
              onChange={() => onChange(value)}
              value={value}
              ref={ref}
            />
            <Text.MDMedium>{t(`salutations.${key}`)}</Text.MDMedium>
          </Label>
        ))}
      </RadioContainer>
      <BottomMessage error={error} />
    </GenderSelectorContainer>
  ),
);

export default GenderSelector;
